import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionPanel',
  props: {
    outlined: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})